<template>
    <div class="f2g-wind-container">
        <div class="modal-force" v-show="showModal">
            <div class="modal-overlay-force" @click="closeModal"></div>
            <div class="modal-container-force">
                <div class="modal-header-force">
                    <h3>{{ title }}</h3>
                    <button class="modal-close-force" @click="closeModal">
                        <i class="fa-force fa-times-force"></i>
                    </button>
                </div>
                <div class="modal-body-force">
                    <slot></slot>
                </div>
                <div class="modal-footer-force">
                    <button class="modal-btn-force" @click="closeModal">{{ closeBtnText }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "WarningModal",
    data: function () {
        return { 
            show: true, 
        }
    },
    computed: {
        title() {
            return this.$store.state.forcePersonalDataMessage;
        },
        showWarningModal() {
            return this.$store.state.showWarningModal;
        },
        closeBtnText() {
            if(this.getLocale == "el")
                return "Κλείσιμο";
            else
                return "Close";
        },
        showModal(){
            return this.show;
        },
        getLocale() {
            var locale;
            if ($("body").data("locale") == "el_GR") {
                locale = "el";
            } else {
                locale = "en";
            }
            return locale;
        },
    },
    methods: {
        closeModal() {
            this.show=false;
        }
    }
}
</script>
<style scoped>
</style>
